var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-23138afe]{padding:0}.rank-name[data-v-23138afe]{margin-top:.5em;font-size:1.3em;font-weight:500}.rank-item[data-v-23138afe]{margin:2em 1em;background:url(" + escape(require("../../assets/box-sale.png")) + ");background-size:cover;border-radius:20px;overflow:hidden}.img-rank[data-v-23138afe]{overflow:hidden;width:70px;height:70px;margin:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23138afe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Rank/RankItem.vue
// module id = NAtN
// module chunks = 1